import { getLanguage } from "CMS/utils";

export const nounToLower = (noun: string) => {
  if (serverReference.culture.uiLanguage === "de") { return noun; }
  return noun.charAt(0).toLowerCase() + noun.slice(1);
};

/**
 * Formats a main area item with count. For example, "1 show" or "2 shows".
 * For german, the noun is not lowercased.
 */
export const formatMainAreaItemWithCount = (count: number, mainArea: server.dto.MainAreas) => {
  const noun = count === 1
    ? site.currentEnvironment[mainArea].singular
    : site.currentEnvironment[mainArea].plural;

  return `${count} ${nounToLower(noun)}`;
};


const languagesSet = new Set(serverReference.languages.map(l => l.value));
const pick = (value: server.dto.Languages) => {
  languagesSet.delete(value);
  return value;
}

const languageOrderArray = [
  pick("english"),
  pick("german"),
  pick("dutch"),
  pick("portuguese"),
  pick("spanish"),
  ...languagesSet
]

const languageOrderMap = new Map<server.dto.Languages, number>();
languageOrderArray.forEach((lang, index) => languageOrderMap.set(lang, index));

export const compareLanguages = (a: server.dto.Languages, b: server.dto.Languages): number => {
  const aIndex = languageOrderMap.get(a);
  const bIndex = languageOrderMap.get(b);
  return aIndex - bIndex;
}

export const sortLanguages = (languages: server.dto.Languages[]) => {
  return [...languages].sort(compareLanguages);
}

export const localizedLanguageSort = (a: server.dto.Languages, b: server.dto.Languages) => {
  return getLanguage(a).localizedName.localeCompare(getLanguage(b).localizedName);
}